// extracted by mini-css-extract-plugin
module.exports = {"column":"_8QfCap","title":"mo4cQt","linksList":"y_lfCP","link":"_0FqOAY","item":"jr9AOE"};